// src/libs/Api/Comments.js
import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAll extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Comment/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data); // query params
  }
}

class CreateComment extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Comment/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data); // body
  }
}

class UpdateComment extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Comment/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data); // body
  }
}

class DeleteBy extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Comment/DeleteBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data); // ?id=...
  }
}

export { GetAll, CreateComment, UpdateComment, DeleteBy };
